import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-desk/admin`;
const inp = 'w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm';
const FEES = [['mint_fee_pct', 'Mint (buy) fee %'], ['redeem_fee_pct', 'Redeem (cash-out) fee %'], ['swap_fee_pct', 'Approved swap service fee %']];

const save = async (fn, done) => {
  try { const r = await fn(); toast.success(r.data.message); done(); }
  catch (e) { toast.error(e.response?.data?.detail?.toString() || 'Failed'); }
};

export const DeskFeeSettings = ({ token, settings, onSaved }) => {
  const [f, setF] = useState(() => Object.fromEntries(FEES.map(([k]) => [k, settings[k]])));
  const body = Object.fromEntries(Object.entries(f).map(([k, v]) => [k, parseFloat(v)]));
  const valid = Object.values(body).every(v => v >= 0 && v <= 10);
  return (
    <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 space-y-3" data-testid="desk-fee-settings">
      <h3 className="text-white font-semibold">Fees</h3>
      {FEES.map(([k, label]) => (
        <label key={k} className="flex items-center justify-between gap-3 text-sm text-slate-300">{label}
          <input type="number" min="0" max="10" step="0.05" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${inp} w-28`} data-testid={`fee-${k}`} />
        </label>
      ))}
      <button disabled={!valid} data-testid="fee-save-btn" className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-40 text-white rounded-lg text-sm font-semibold"
        onClick={() => save(() => axios.put(`${API}/settings`, body, { headers: { Authorization: `Bearer ${token}` } }), onSaved)}>Save fees</button>
      <p className="text-xs text-slate-500">New fees apply to new requests only. Swap fees are taken in the token being swapped and sent to the treasury wallet.</p>
    </div>
  );
};

export const InterestForm = ({ token, onSaved }) => {
  const [f, setF] = useState({ amount_usd: '', period: '', note: '' });
  const amount = parseFloat(f.amount_usd);
  return (
    <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 space-y-3" data-testid="interest-form">
      <h3 className="text-white font-semibold">Record reserve interest</h3>
      <p className="text-xs text-slate-400">Interest your bank or Treasury bills paid on reserve dollars. Entered by hand from your statement.</p>
      <input type="number" min="0" step="0.01" placeholder="Amount (USD)" value={f.amount_usd} onChange={(e) => setF({ ...f, amount_usd: e.target.value })} className={inp} data-testid="interest-amount" />
      <input placeholder="Period, e.g. June 2026" value={f.period} onChange={(e) => setF({ ...f, period: e.target.value })} className={inp} data-testid="interest-period" />
      <input placeholder="Note (optional), e.g. T-bill yield" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} className={inp} data-testid="interest-note" />
      <button disabled={!(amount > 0) || f.period.trim().length < 3} data-testid="interest-save-btn" className="px-4 py-2 bg-violet-600 hover:bg-violet-500 disabled:opacity-40 text-white rounded-lg text-sm font-semibold"
        onClick={() => save(() => axios.post(`${API}/interest`, { ...f, amount_usd: amount }, { headers: { Authorization: `Bearer ${token}` } }),
          () => { setF({ amount_usd: '', period: '', note: '' }); onSaved(); })}>Record interest</button>
    </div>
  );
};
